import { useMap } from "react-leaflet";
import { Fab, Stack } from "@mui/material";
import { Add, Remove } from "@mui/icons-material";
import { ControlOptions } from "leaflet";

import { MapControlBase } from "./utils/MapControlBase";

interface MapZoomControlProps extends ControlOptions {}

export function MapZoomControls(props: MapZoomControlProps) {
  const { ...controlOptions } = props;
  const map = useMap();

  function handleZoom(direction: "in" | "out") {
    if (direction === "in") map.setZoom(map.getZoom() + 1);
    if (direction === "out") map.setZoom(map.getZoom() - 1);
  }

  return (
    <MapControlBase {...controlOptions}>
      <Stack gap={1}>
        <Fab size="small" onClick={(e) => handleZoom("in")}>
          <Add />
        </Fab>

        <Fab size="small" onClick={(e) => handleZoom("out")}>
          <Remove />
        </Fab>
      </Stack>
    </MapControlBase>
  );
}
